import React, { useEffect, useState } from 'react';

export default function Loader() {
   const [show, setShow] = useState(true);

   useEffect(() => {
      const timeout = setTimeout(() => {
         setShow(false);
      }, 3000);

      return () => {
         clearTimeout(timeout);
      };
   }, [show]);

   return (
      <>
         {show && (
            <div className="loader-wrapper position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75">
               <div className="loader">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
               </div>
            </div>
         )}
      </>
   );
}
